"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDidomi = renderDidomi;
exports.renderThirdPartyScripts = renderThirdPartyScripts;
var _config = require("@ori-appshell/config");
var _jsxRuntime = require("react/jsx-runtime");
function getGoogleAnalyticsModel(gtmConfiguration) {
  return {
    GtmId: gtmConfiguration?.gtmId
  };
}
function renderBaiduScriptUrl({
  thirdPartyConfigurationBaidu
}) {
  const scriptUrl = thirdPartyConfigurationBaidu?.scriptUrl;
  if (!scriptUrl) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
    // eslint-disable-next-line react/no-danger -- third party script
    dangerouslySetInnerHTML: {
      __html: `
          var _hmt = _hmt || [];
          (function() {
            var hm = document.createElement('script');
            hm.src = '${scriptUrl}';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(hm, s);
          })();
        `
    }
  });
}
function renderGoogleAnalytics({
  gtmConfiguration,
  clientAppsUrl,
  environment
}) {
  if (!gtmConfiguration?.gtmId) {
    return null;
  }
  const model = getGoogleAnalyticsModel(gtmConfiguration);
  const encodedModel = JSON.stringify(model);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      id: "analytics-provider-data",
      type: "application/json",
      crossOrigin: "anonymous"
      // eslint-disable-next-line react/no-danger -- we don't want the encoded model escaped
      ,
      dangerouslySetInnerHTML: {
        __html: encodedModel
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
      defer: true,
      crossOrigin: "anonymous",
      src: (0, _config.createSpaEntryfileUrl)('analytics-provider', environment, clientAppsUrl)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("noscript", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
        title: "gtm",
        src: `//www.googletagmanager.com/ns.html?id=${gtmConfiguration.gtmId}`,
        height: "0",
        width: "0"
      })
    })]
  });
}

/** Didomi is a new cookie provider that replaced onetrust */
function renderDidomi(didomiConfiguration) {
  if (!didomiConfiguration?.scriptDomain || !didomiConfiguration.didomiId || !didomiConfiguration.didomiTag) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("script", {
    id: "spcloader",
    type: "text/javascript",
    src: `${didomiConfiguration.scriptDomain}/${didomiConfiguration.didomiId}/loader.js?target_type=notice&target=${didomiConfiguration.didomiTag}`
  });
}
function renderThirdPartyScripts({
  thirdPartyConfiguration,
  thirdPartyConfigurationBaidu,
  clientAppsUrl,
  environment
}) {
  if (!thirdPartyConfiguration) {
    return null;
  }
  const scripts = [renderGoogleAnalytics({
    gtmConfiguration: thirdPartyConfiguration.gtm,
    clientAppsUrl,
    environment
  }), renderBaiduScriptUrl({
    thirdPartyConfigurationBaidu
  })].filter(Boolean);
  return scripts.length > 0 ? scripts : null;
}
